module.exports = __webpack_public_path__ + "assets/b110.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b110.png
// module id = 582
// module chunks = 0